import jscookie from 'js-cookie'
import { AUTH_COOKIE } from '@/store/modules/user'

const esriToken		=	jscookie.get(AUTH_COOKIE)

const state = {	
	useBetaGIS 		: false,
	serviceURL 		: 'https://services.maps.arizona.edu/pdc/rest/services',
	productionURL	: 'https://services.maps.arizona.edu/pdc/rest/services',
	betaURL			: 'https://pdc-betagis2.bluecat.arizona.edu:6443/arcgis/rest/services/',	
	subBasemapURL 	:	'http://services.arcgisonline.com/arcgis/rest/services/Canvas/World_Light_Gray_Base/MapServer',
	darkBasemap 	: 	'https://services.arcgisonline.com/arcgis/rest/services/Canvas/World_Dark_Gray_Base/MapServer',
	floorToInteriorSublayerId 	:  { 
		"B1": 	"14",
		"B": 	"15",
		"1": 	"16",
		"2": 	"17",
		"3": 	"18",
		"4": 	"19",
		"5": 	"20",
		"6": 	"21",
		"7": 	"22",
		"8": 	"23",
		"9": 	"24",
		"10": 	"25",
		"11": 	"26",
		"12": 	"27",
	}
}

const mutations = {
	setUseBetaGIS(state, payload) {
		console.log("Setting useBetaGIS ", payload)
	    state.useBetaGIS = payload
	    if (payload) {
	    	state.serviceURL = state.betaURL
	    	console.log("Using ", state.serviceURL)
	    } /* else {
	    	state.state.serviceURL = state.productionURL
	    }*/
	},
}

const getters = {

	tokenURL: function (state, rootState) {
		return state.useBetaGIS ? "https://pdc-betagis2.catnet.arizona.edu:6443/arcgis/tokens/generateToken" : "https://services.maps.arizona.edu/pdc/tokens/generateToken" 
	},

	floorURL : function (state) {
		return {
			"B1": state.serviceURL + "/Interior/MapServer/14",
			"B": state.serviceURL + "/Interior/MapServer/15",
			"1": state.serviceURL + "/Interior/MapServer/16",
			"2": state.serviceURL + "/Interior/MapServer/17",
			"3": state.serviceURL + "/Interior/MapServer/18",
			"4": state.serviceURL + "/Interior/MapServer/19",
			"5": state.serviceURL + "/Interior/MapServer/20",
			"6": state.serviceURL + "/Interior/MapServer/21",
			"7": state.serviceURL + "/Interior/MapServer/22",
			"8": state.serviceURL + "/Interior/MapServer/23",
			"9": state.serviceURL + "/Interior/MapServer/24",
			"10": state.serviceURL + "/Interior/MapServer/25",
			"11": state.serviceURL + "/Interior/MapServer/26",
			"12": state.serviceURL + "/Interior/MapServer/27",
			"1M": state.serviceURL + "/Interior/MapServer/33",
			"2M": state.serviceURL + "/Interior/MapServer/34",
			"3M": state.serviceURL + "/Interior/MapServer/35",
			"4M": state.serviceURL + "/Interior/MapServer/36",
		}
	},

	planURL : function (state) {
		return {
			"B1": state.serviceURL + "/Interior/MapServer/0",
			"B": state.serviceURL + "/Interior/MapServer/1",
			"1": state.serviceURL + "/Interior/MapServer/2",
			"2": state.serviceURL + "/Interior/MapServer/3",
			"3": state.serviceURL + "/Interior/MapServer/4",
			"4": state.serviceURL + "/Interior/MapServer/5",
			"5": state.serviceURL + "/Interior/MapServer/6",
			"6": state.serviceURL + "/Interior/MapServer/7",
			"7": state.serviceURL + "/Interior/MapServer/8",
			"8": state.serviceURL + "/Interior/MapServer/9",
			"9": state.serviceURL + "/Interior/MapServer/10",
			"10": state.serviceURL + "/Interior/MapServer/11",
			"11": state.serviceURL + "/Interior/MapServer/12",
			"12": state.serviceURL + "/Interior/MapServer/13",
			"1M": state.serviceURL + "/Interior/MapServer/29",
			"2M": state.serviceURL + "/Interior/MapServer/30",
			"3M": state.serviceURL + "/Interior/MapServer/31",
			"4M": state.serviceURL + "/Interior/MapServer/32",
		}
	},

	securePlanURL : function (state) {
		return {
			"B1": state.serviceURL + "/InteriorRestricted/MapServer/0",
			"B": state.serviceURL + "/InteriorRestricted/MapServer/1",
			"1": state.serviceURL + "/InteriorRestricted/MapServer/2",
			"2": state.serviceURL + "/InteriorRestricted/MapServer/3",
			"3": state.serviceURL + "/InteriorRestricted/MapServer/4",
			"4": state.serviceURL + "/InteriorRestricted/MapServer/5",
			"5": state.serviceURL + "/InteriorRestricted/MapServer/6",
			"6": state.serviceURL + "/InteriorRestricted/MapServer/7",
			"7": state.serviceURL + "/InteriorRestricted/MapServer/8",
			"8": state.serviceURL + "/InteriorRestricted/MapServer/9",
			"9": state.serviceURL + "/InteriorRestricted/MapServer/10",
			"10": state.serviceURL + "/InteriorRestricted/MapServer/11",
			"11": state.serviceURL + "/InteriorRestricted/MapServer/12",
			"12": state.serviceURL + "/InteriorRestricted/MapServer/13",
			"1M": state.serviceURL + "/InteriorRestricted/MapServer/29",
			"2M": state.serviceURL + "/InteriorRestricted/MapServer/30",
			"3M": state.serviceURL + "/InteriorRestricted/MapServer/31",
			"4M": state.serviceURL + "/InteriorRestricted/MapServer/32",
		}
	},

	secureFloorURL : function (state) {
		return {
			"B1": state.serviceURL + "/InteriorRestricted/MapServer/14",
			"B": state.serviceURL + "/InteriorRestricted/MapServer/15",
			"1": state.serviceURL + "/InteriorRestricted/MapServer/16",
			"2": state.serviceURL + "/InteriorRestricted/MapServer/17",
			"3": state.serviceURL + "/InteriorRestricted/MapServer/18",
			"4": state.serviceURL + "/InteriorRestricted/MapServer/19",
			"5": state.serviceURL + "/InteriorRestricted/MapServer/20",
			"6": state.serviceURL + "/InteriorRestricted/MapServer/21",
			"7": state.serviceURL + "/InteriorRestricted/MapServer/22",
			"8": state.serviceURL + "/InteriorRestricted/MapServer/23",
			"9": state.serviceURL + "/InteriorRestricted/MapServer/24",
			"10": state.serviceURL + "/InteriorRestricted/MapServer/25",
			"11": state.serviceURL + "/InteriorRestricted/MapServer/26",
			"12": state.serviceURL + "/InteriorRestricted/MapServer/27",
			"1M": state.serviceURL + "/InteriorRestricted/MapServer/29",
			"2M": state.serviceURL + "/InteriorRestricted/MapServer/30",
			"3M": state.serviceURL + "/InteriorRestricted/MapServer/31",
			"4M": state.serviceURL + "/InteriorRestricted/MapServer/32",
		}
	},

	initialFeaturesURL : function (state) {
		return {
			"B1": state.serviceURL + "/InteriorInitial/MapServer/14",
			"B": state.serviceURL + "/InteriorInitial/MapServer/15",
			"1": state.serviceURL + "/InteriorInitial/MapServer/16",
			"2": state.serviceURL + "/InteriorInitial/MapServer/17",
			"3": state.serviceURL + "/InteriorInitial/MapServer/18",
			"4": state.serviceURL + "/InteriorInitial/MapServer/19",
			"5": state.serviceURL + "/InteriorInitial/MapServer/20",
			"6": state.serviceURL + "/InteriorInitial/MapServer/21",
			"7": state.serviceURL + "/InteriorInitial/MapServer/22",
			"8": state.serviceURL + "/InteriorInitial/MapServer/23",
			"9": state.serviceURL + "/InteriorInitial/MapServer/24",
			"10": state.serviceURL + "/InteriorInitial/MapServer/25",
			"11": state.serviceURL + "/InteriorInitial/MapServer/26",
			"12": state.serviceURL + "/InteriorInitial/MapServer/27",
			"1M": state.serviceURL + "/InteriorInitial/MapServer/33",
			"2M": state.serviceURL + "/InteriorInitial/MapServer/34",
			"3M": state.serviceURL + "/InteriorInitial/MapServer/35",
			"4M": state.serviceURL + "/InteriorInitial/MapServer/36",
		}
	},

	initialTextURL : function (state) {
		return {
			"B1": state.serviceURL + "/InteriorInitial/MapServer/37",
			"B": state.serviceURL + "/InteriorInitial/MapServer/52",
			"1": state.serviceURL + "/InteriorInitial/MapServer/39",
			"2": state.serviceURL + "/InteriorInitial/MapServer/40",
			"3": state.serviceURL + "/InteriorInitial/MapServer/41",
			"4": state.serviceURL + "/InteriorInitial/MapServer/43",
			"5": state.serviceURL + "/InteriorInitial/MapServer/44",
			"6": state.serviceURL + "/InteriorInitial/MapServer/45",
			"7": state.serviceURL + "/InteriorInitial/MapServer/46",
			"8": state.serviceURL + "/InteriorInitial/MapServer/47",
			"9": state.serviceURL + "/InteriorInitial/MapServer/48",
			"10": state.serviceURL + "/InteriorInitial/MapServer/49",
			"11": state.serviceURL + "/InteriorInitial/MapServer/50",
			"12": state.serviceURL + "/InteriorInitial/MapServer/51",
			//"1M": state.serviceURL + "/InteriorInitial/MapServer/51",
			//"2M": state.serviceURL + "/InteriorInitial/MapServer/52",
			//"3M": state.serviceURL + "/InteriorInitial/MapServer/53",
			//"4M": state.serviceURL + "/InteriorInitial/MapServer/54",
		}
	},

	buildingFootprintURL : 	function (state) {	return state.serviceURL + "/EnterpriseFeatures/MapServer/74"					},
	lightBasemapURL :  		function (state) {	return state.serviceURL + '/SubtleCanvasTiles/MapServer'						},
	phxBasemapURL :			function (state) {	return state.serviceURL + '/SubtleCanvasTilesPBC/MapServer'					},
	CACBasemapURL :			function (state) {	return state.serviceURL + '/SubtleCanvasTilesCAC/MapServer'					},
	B2BaseMapURL : 			function (state) {	return state.serviceURL + '/SubtleCanvasTilesB2/MapServer'					},
	TPBaseMapURL :			function (state) {	return state.serviceURL + '/SubtleCanvasTilesTechPark/MapServer'				},
	UASouthBaseMapURL : 	function (state) {	return state.serviceURL + '/SubtleCanvasTilesUASouth/MapServer'				},			
	darkInterior : 			function (state) {	return state.serviceURL + '/InteriorDark/MapServer/'							},
	lightInteriorOpen : 	function (state) {	return state.serviceURL + '/Interior/MapServer/'								},
	maskingLayerURL	: 		function (state) {	return state.serviceURL + '/EnterpriseFeatures/MapServer/'					},
	lightInteriorSecured : 	function (state) {	let esriToken		=	jscookie.get(AUTH_COOKIE); return state.serviceURL + '/InteriorRestricted/MapServer?token=' + esriToken	},
	subBasemapURL : 		function (state) {  return 'http://services.arcgisonline.com/arcgis/rest/services/Canvas/World_Light_Gray_Base/MapServer'},
	darkBasemap : 			function (state) {  return 'https://services.arcgisonline.com/arcgis/rest/services/Canvas/World_Dark_Gray_Base/MapServer'},

}

const actions = {
}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/restServices.js